export default function FlightSeatmapService(
    userService,
    l10nService,
) {
    'ngInject';

    Object.assign(this, {
        getTextForSeatmapWarning,
    });

    function getTextForSeatmapWarning() {
        const standardText = l10nService.localize('We recommend to proceed with booking immediately as the selected seat/s cannot be guaranteed');
        const additionalInfoForUKusers = l10nService.localize('Please note that only free of charge seats can be selected.');
        return userService.isUSRegion()
            ? `${standardText}`
            : `${standardText} <br> ${additionalInfoForUKusers}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-seatmap/flight-seatmap-service.js